import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Pagination, Offcanvas, Card, Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { formatDateTime } from "../../utils/Helper";
import DeleteModal from "../../components/common/DeleteModel";
import useMenuPermissions from "../../components/CustomHook/custompermission";

const ManagerDetails = () => {
  const { id } = useParams();
  const [rmDetails, setRmDetails] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [showDt, setShowDt] = useState(false);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const permissionscontext = useMenuPermissions('/admin/rm-list');
  const navigate = useNavigate();

  useEffect(() => {
    fetchRmDetails();
  }, []);

  const fetchRmDetails = async () => {
    try {
      const response = await APIServices.get(
        `/admin/relationship_manager/details/${id}`,
        headers
      );
      if (response?.status === 200) {
        setRmDetails(response?.data?.details || []);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setRmDetails({});
      }
    } catch (error) {
      setRmDetails({});
    }
  };

  const handleDeleterm = async () => {
    try {
      if (selectedId !== null) {
        const payload = { id: selectedId };
        const res = await APIServices.post(
          `/admin/relationship_manager/delete`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          navigate("/admin/rm-list");
          setSelectedId(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };

  const handleStatusChange = async (chPatner) => {
    const newStatus = chPatner.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: chPatner.id, status: newStatus };
      const res = await APIServices.post(
        `/admin/relationship_manager/status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        fetchRmDetails();
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      showToast("Error updating status", "error");
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="channel_details_inner manager_details_sec">
        <h2 className="font_blue_18 font-600 mb-3">Manager Details</h2>

        <div className="channel_details ">
          <div className="cd_header">
            <Row className="align-items-center">
              <Col md={8}>
                <div class="ch_name d-flex align-items-center">

                  {
                    rmDetails?.profile_pic ?
                      <img
                        src={rmDetails.profile_pic}
                        className="img-fluid me-2 table_user"
                        alt={rmDetails.first_name}
                        onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                      />
                      :
                      <img src="/images/placeholder-img.jpg"
                        className='img-fluid me-2 table_user'
                        alt="default img"
                      />
                  }

                  <p className="font_blue_18 font-500 textTransform">{rmDetails?.fullname}</p>
                </div>
              </Col>
              <Col md={4}>
                <ul className="d-flex align-items-center justify-content-end gap-2">
                  <li>
                    <button
                      disabled={!permissionscontext.delete}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        cursor: !permissionscontext.delete
                          ? "not-allowed"
                          : "pointer",
                        opacity: !permissionscontext.delete ? 0.5 : 1,
                      }}
                      onClick={() => {
                        setSelectedId(rmDetails.id);
                        setShowDt(true);
                      }}
                    >
                      <img
                        src="/images/Trash.svg"
                        className="img-fluid trash"
                        alt="trash"
                      />
                    </button>
                  </li>
                  <li>
                    <button
                      disabled={!permissionscontext.edit}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        cursor: !permissionscontext.edit
                          ? "not-allowed"
                          : "pointer",
                        opacity: !permissionscontext.edit ? 0.5 : 1,
                      }}
                      onClick={() =>
                        navigate(`/admin/update-rm/${rmDetails.id}`, {
                          state: { row: rmDetails },
                        })
                      }
                    >
                      <img
                        src="/images/Pen.svg"
                        className="img-fluid pen"
                        alt="pen"
                        onClick={() =>
                          navigate(`/admin/update-rm/${rmDetails.id}`, {
                            state: { row: rmDetails },
                          })
                        }
                      />
                    </button>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>

          <div className="cd_body mt-4">
            <Row className="all_details">
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">
                    Registered Date
                  </h4>
                  <p className="font_blue_16 ">
                    {formatDateTime(rmDetails?.created)}
                  </p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Phone No</h4>
                  <p className="font_blue_16">
                    {rmDetails?.mobile
                      ? `( ${rmDetails?.country_code}) ${rmDetails?.mobile}`
                      : 'N/A'}
                  </p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Email ID</h4>
                  <p className="font_blue_16 ">{rmDetails?.email ? rmDetails?.email : "N/A"}</p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Region</h4>
                  <p className="font_blue_16 ">{rmDetails?.region_name}</p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Status</h4>
                  <p className="font_blue_16 d-flex align-items-center">
                    {rmDetails?.status}{" "}
                    <Form className="Switch_toggle ms-2 position-relative">
                      <input
                        type="checkbox"
                        id={`switch-${rmDetails?.id}`}
                        checked={rmDetails?.status === "Active"}
                        onClick={() => handleStatusChange(rmDetails)}
                        disabled={!permissionscontext.edit}
                      />
                      <label
                        htmlFor={`switch-${rmDetails?.id}`}
                        className="position-absolute"
                      >
                        Toggle
                      </label>
                    </Form>
                  </p>
                </div>
              </Col>
              <Col md={4} lg={4}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Type</h4>
                  <p className="font_blue_16 round_border">
                    {rmDetails?.relationship_manager_type}
                  </p>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Location</h4>
                  <p className="font_blue_16 ">
                    {` ${rmDetails?.city_name} (${rmDetails?.state_name}), ${rmDetails?.country_name}, ${rmDetails?.pin_code}`}
                  </p>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div className="d-flex align-items-center  gap-2 ">
                  <h4 className="font_blue_16 font-500">Channel Partners:</h4>
                  <div class="d-flex align-items-center">

                    <p>{rmDetails?.channel_partner_name}</p>
                  </div>
                </div>
              </Col>
              <Col md={12} lg={12}>
                <div>
                  <h4 className="font_blue_16 font-500 mb-2">Details</h4>
                  <p className="font_blue_16 ">{rmDetails?.description}</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => setShowDt(false)}
        handledelete={handleDeleterm}
      />
      <ToastContainer />
    </>
  );
};

export default ManagerDetails;
